import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import { Drawer, ScrollBox, Select } from '@agencypmg/alli';
import { applications } from '@alli/frontend-common';
import MobileMenuItem from './MobileMenuItem';
import ClientSelector from './ClientSelector';
import * as support from '../../support';

const { Option } = Select;

const supportItem = {
    href: support.link,
    iconPath: support.iconPath,
    target: '_blank',
    name: 'Support',
    id: 'support',
};

export default function MobileMenu({
    show,
    setShow,
    changeClient,
    currentClient,
    currentApp,
    currentUser,
    activeSubnavItem,
    clients,
    navigateToUrl,
}) {
    const onSelect = useCallback(
        slug => {
            changeClient(slug);
            setShow(false);
        },
        [changeClient, setShow],
    );

    const onMenuItemClick = useCallback(
        event => {
            setShow(false);
            navigateToUrl(event);
        },
        [navigateToUrl, setShow],
    );

    return (
        <Drawer
            zIndex="z-50"
            show={show}
            width="w-64"
            toggleDrawer={() => setShow(false)}
            wrapperClass="mobile-menu"
            overlay
            bodyFullHeight
        >
            <ScrollBox
                width="w-full"
                bg="bg-gray-100"
                header={
                    <div className="border-b border-gray-400 bg-gray-100 px-4 pt-5 pb-3 leading-none">
                        <Logo className="h-6 w-10" currentUser={currentUser} />
                    </div>
                }
            >
                <div className="pt-5 text-13 font-normal text-blue-gray-600 w-full px-4">
                    <ClientSelector
                        clients={clients}
                        currentClient={currentClient}
                        onClientSelect={onSelect}
                    />

                    {applications.mapAllMenu((item, id) => {
                        if (!currentClient) {
                            return null;
                        }

                        const subNav = item.subNav
                            ?.map(id => {
                                const subItem = item.subNavItems[id];
                                if (!subItem) {
                                    return null;
                                }

                                return {
                                    ...subItem,
                                    href: applications.renderClientUrl(
                                        currentClient,
                                        subItem,
                                    ),
                                };
                            })
                            ?.filter(Boolean);

                        const finalItem = {
                            ...item,
                            subNav,
                            href: applications.renderClientUrl(
                                currentClient,
                                item,
                            ),
                        };

                        return (
                            <MobileMenuItem
                                key={`mobilemenu-${id}`}
                                item={finalItem}
                                isActive={currentApp === id}
                                activeSubnavItem={activeSubnavItem}
                                navigateToUrl={onMenuItemClick}
                            />
                        );
                    })}
                    <MobileMenuItem
                        key="mobilemenu-support"
                        item={supportItem}
                        isActive={false}
                        navigateToUrl={navigateToUrl}
                    />
                </div>
            </ScrollBox>
        </Drawer>
    );
}
